import { CinemaDto } from '@cineamo/api/models/cinema/CinemaDto.types';
import { MovieDto } from '@cineamo/api/models/movie/v2/MovieDto.types';
import { ShowingDto } from '@cineamo/api/models/showing/ShowingDto.types';

import { ShowingListResponse, ShowingTagListResponse } from '@cineamo/api/types/ApiListResponse.types';
import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

import { API_URL } from '@/constants/http-constants';

import apiClient from '@/utils/api/cineamoApiClient';
import { ShowingApiEmbed } from '@cineamo/api/resources/showing/showing-api.embed';
import { ShowingApiGroup } from '@cineamo/api/resources/showing/showing-api.group';

import { buildUrlQuery, UrlQueryParameter } from '@/helpers/url-query-helper';

export type GetShowingsQuery = {
    contentId?: string | number;
    cinemaIds?: number[] | string[];
    startDatetime?: string;
    endDatetime?: string;
    movieId?: MovieDto['id'];
    name?: string;
    longitude?: number;
    latitude?: number;
    distance?: number;
    isRegularShowtime?: boolean;
    isEventRequest?: boolean;
    isThreeDimensional?: boolean;
    hasMovie?: boolean;
    group?: ShowingApiGroup;
    embed?: ShowingApiEmbed[];
    cinemaRoomIds?: number[] | string[];
    showingTagIds?: number[] | string[];
    hasShowingTags?: boolean;
    language?: string;
    subtitledLanguage?: string;
    isSubtitled?: boolean;
    isDubbed?: boolean;
    dubbedLanguage?: string;
    isDolbyAtmos?: boolean;
    isImax?: boolean;
    isDolbyVision?: boolean;
    isDolbyCinema?: boolean;
    is4DX?: boolean;
    isScreenX?: boolean;
    isHFR?: boolean;
    isLive?: boolean;
    isDbox?: boolean;
    isHighlightAfterDatetime?: string;
    isHighlighted?: boolean;
} & UrlQueryParameter;

/**
 * @deprecated use getFutureShowings instead
 */
export async function getShowings(query: GetShowingsQuery): Promise<ApiResponse<ShowingListResponse>> {
    return await apiClient
        .get(`${API_URL}/showings${buildUrlQuery(query)}`)
        .then((response) => response)
        .catch(() => {
            return null;
        });
}

export type GetFutureShowingsQuery = {
    showingTagIds?: number[] | string[];
    hasShowingTags?: boolean;
};

/**
 * Pure API function - fetches raw showings data without filtering
 */
export async function getFutureShowings(
    cinemaId: CinemaDto['id'] | string,
    query?: GetFutureShowingsQuery | null
): Promise<ApiResponse<unknown, ShowingListResponse>> {
    return await apiClient
        .get(`${API_URL}/cinemas/${cinemaId}/showings-future${buildUrlQuery(query)}`, {
            credentials: 'same-origin'
        })
        .catch(() => {
            return null;
        });
}

export async function getShowingById(showingId: ShowingDto['id'] | string): Promise<ApiResponse<ShowingDto>> {
    return await apiClient
        .get(`${API_URL}/showings/${showingId}`)
        .then((response) => response)
        .catch(() => {
            return null;
        });
}

type GetShowingTagsParams = UrlQueryParameter;
export async function getShowingTags(
    showingId: ShowingDto['id'] | string,
    params?: GetShowingTagsParams
): Promise<ApiResponse<ShowingTagListResponse>> {
    return await apiClient
        .get(`${API_URL}/showings/${showingId}/tags${buildUrlQuery(params)}`, {
            credentials: 'same-origin'
        })
        .then((response) => response)
        .catch(() => {
            return null;
        });
}
